$().ready(function(){
    $("#login_form").submit(function(e){
        e.preventDefault();
        var form = $("#login_form");

        if (form.find("#email").val() == '') {
            Swal.fire({
                icon: 'info',
                text: 'Fill in email'
            });
            return;
        }
        if (form.find("#password").val() == '') {
            Swal.fire({
                icon: 'info',
                text: 'Fill in password'
            });
            return;
        }
        var data = form.serialize();
        $.ajax({
            url: form.attr('action'),
            type: 'post',
            dataType: 'json',
            data: data,
            error: function(response){
                var message = '';
                if (response.responseJSON.message != undefined) {
                    message = response.responseJSON.message;
                } else if (response.responseJSON.errors != undefined) {
                    message = [];
                    $.each(response.responseJSON.errors, function(i, v){
                        $.each(response.responseJSON.errors, function(i2, v2){
                            message.push(v2);
                        });
                    });
                    message = message.join('. ');
                } else {
                    message = 'Oops something went wrong, please try again';
                }

                Swal.fire({
                    icon: 'error',
                    text: message
                });
            },
            success: function(response){
                document.location.href = '/portal';
            },
        });
    });
});